<!-- Start Cookie Acceptance -->
<section *ngIf="!isCookieNoticeAccepted" class="cookie-acceptance text-dark bg-app-secondary py-2">
  <p class="text-center px-2 mb-0">
    <b>Cookies Acceptance</b> Brandnew uses cookies to give our user the best possible
    experience,byusing this websites you agree to our cookie policy.
    <button class="btn bg-white" (click)="acceptCookie()">ACCEPT</button>
  </p>
</section>
<!-- End Cookie Acceptance -->
<header>
  <nav class="navbar navbar-light bg-app-primary">
    <div class="container-fluid">
      <a class="navbar-brand" href="/">
        <img decoding="async" src="/assets/images/logo.png" alt="Logo" class="d-inline-block align-text-top">
      </a>

      <!-- desktop section -->
      <section class="d-none d-md-block">
        <!-- Toggle Menu -->
        <div class="pe-0 pe-md-4 position-relative">
          <button class="app-icon-btn align-item-end" (click)="toggleMenu()">
            <i class="bi bi-list"></i>
          </button>
          <div [ngClass]="isToggleMenuVisble ? 'toggle-menu-active' : '' "
            class="toggle-menu-content bg-app-primary-light me-md-4">
            <a routerLink="/profile" *ngIf="authServe.isLoggedIn" (click)="toggleMenu()">Dashboard</a>
            <a *ngIf="!authServe.isLoggedIn" href="" (click)="login($event)">Login</a>
            <a *ngIf="!authServe.isLoggedIn" href="" (click)="signup($event)">Signup</a>
            <a href="" *ngIf="authServe.isLoggedIn" (click)="logout($event)">Logout</a>
            <!-- <a href="" (click)="toggleMenu()">Contact Us</a> -->
          </div>
        </div>
      </section>

      <!-- mobile toggle menu -->
      <section class="d-md-none">
        <div class="pe-0 pe-md-4 position-relative">
          <button class="app-icon-btn align-item-end" (click)="toggleMobileMenu()">
            <i class="bi bi-list"></i>
          </button>
          <div *ngIf="!authServe.isLoggedIn" [ngClass]="isToggleMobileMenuVisble ? 'toggle-menu-active' : '' "
            class="toggle-menu-content bg-app-primary-light me-md-4">
            <a *ngIf="!authServe.isLoggedIn" href="" (click)="login($event)">Login</a>
            <a *ngIf="!authServe.isLoggedIn" href="" (click)="signup($event)">Signup</a>
            <!-- <a href="" (click)="toggleMobileMenu()">Contact Us</a> -->
          </div>
        </div>
      </section>

    </div>
  </nav>

  <!-- mobile navbar -->
  <section *ngIf="authServe.isLoggedIn">
    <div class="pe-0 pe-md-4">
      <div [ngClass]="isToggleMobileMenuVisble ? 'toggle-mobile-menu-active' : '' "
        class="toggle-mobile-menu-content bg-app-primary-light me-md-4">
        <a class="mt-5" routerLinkActive="active-tab" routerLink="/" *ngIf="authServe.isLoggedIn"
          (click)="toggleMobileMenu()" [routerLinkActiveOptions]="{exact: true}">Home</a>
          <a routerLinkActive="active-tab" routerLink="/profile" *ngIf="authServe.isLoggedIn"
          (click)="toggleMobileMenu()">Profile</a>
        <a routerLinkActive="active-tab" routerLink="/notifications" *ngIf="authServe.isLoggedIn"
          (click)="toggleMobileMenu()">Notifications</a>
        <a routerLinkActive="active-tab" routerLink="/customerorder" *ngIf="authServe.isLoggedIn"
          (click)="toggleMobileMenu()">Customer Order</a>
        <a routerLinkActive="active-tab" routerLink="/store-orders" *ngIf="authServe.isLoggedIn"
          (click)="toggleMobileMenu()">Store Orders</a>
        <!-- <a href="" (click)="toggleMobileMenu()">Contact Us</a> -->
        <a href="" class="mobile-nav-login-btn d-inline-block ms-3 mt-3" *ngIf="authServe.isLoggedIn"
          (click)="logout($event)">Logout</a>
      </div>
    </div>
  </section>
</header>
